import React from 'react'
import sectionThree from'./sectionThree.module.css'
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Privacy from "../../Assets/privacy.jpg"
import Slide3 from "../../Assets/slide3.png"

const SectionThree = () => {
    return (
        <Carousel
            autoPlay={true}
            interval={2000}
            infiniteLoop
        >
            <div className={sectionThree.show1}> 
                <div className={sectionThree.contentPrivacy}>
                    <h1>
                        Say good-bye to other apps <br/>
                        that don't value privacy and <br/>
                        security
                    </h1>
                </div>
                <div className={sectionThree.myImage}>
                    <img  src={Privacy} alt="logo" width="40%" height="90%"/>
                </div>
            </div>
            <div className={sectionThree.show2}>
                <div className={sectionThree.finders}>
                        <h1>
                            We want you to find true love
                        </h1>
                       <div>
                            <h3 className={sectionThree.findersMini}>
                                Imagine our joy when our users find true<br/> and lasting relationships on Aphrodite
                            </h3>
                        </div>
                    </div>
            </div>
            <div className={sectionThree.show3}>
                    <div className={sectionThree.noticeText}>
                        <h1>
                            Get noticed for <span>who</span> you are  and not <span>what</span> you look like
                        </h1>
                        <span>
                            <div>
                                <h3 className={sectionThree.mini}>
                                    Meet new people and explore <br/>the world..you deserve better
                                </h3>
                            </div>
                        </span>
                    </div>
                <div className={sectionThree.myImage}>
                    <img  src={Slide3} alt="logo" width="40%" height="90%"/>
                </div>
            </div>
        </Carousel>
    )
}

export default SectionThree
